import { isStringNullOrEmpty } from '../Annotation/AnnotationForm/Utils';

export const savedKeys = {
  SAVED_HIDDEN_COLUMNS_KEY: 'savedHiddenColumnsAnnotations',
  SAVED_COLUMNS_ORDER_KEY: 'savedColumnsOrderAnnotations'
};

type FindingTemp = {
  id: string;
};

export function findPageWhereFindingIs(
  findings: FindingTemp[],
  currentPage: number,
  pageSize: number,
  selectedAnnotationId: string,
  index: number = 0
): number | null {
  if (!findings || !currentPage) {
    return null;
  }

  const size = findings.length;
  const start = index * pageSize;
  const end = start + pageSize > size ? size : start + pageSize;
  const currentSelected = findings.find(x => x.id === selectedAnnotationId);

  if (!currentSelected) {
    return null;
  }

  const currentIndex = findings.indexOf(currentSelected);

  if (start <= currentIndex && currentIndex < end) {
    return ++index;
  }

  return findPageWhereFindingIs(findings, currentPage, pageSize, selectedAnnotationId, ++index);
}

export function scrollToFindingRow(findingId: string) {
  const element = document.querySelector(`[data-row-key="${findingId}"]`);
  if (!isStringNullOrEmpty(findingId) && element) {
    element.scrollIntoView();
    document.getElementById('main-container')?.scrollTo({ top: 0 });
  }
}
